import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/UI/Typography';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';

const styles = () => ({
  root: {},
});

const MessagesPreferencesLayout = ({
  className,
  classes,
}) => {
  return (
    <div
      className={classNames(classes.root, className)}
    >
      <Typography
        variant={'h2'}
        color={'primary'}
      >
        Notify me via... (must select at least one)
      </Typography>
      <MetaField
        attr="emailNotifications"
      />
      <MetaField
        attr="inAppNotifications"
      />
      <Typography
        variant={'h2'}
        color={'primary'}
      >
        Notify me for...
      </Typography>
      <MetaField
        attr="emojiReactions"
      />
      <MetaField
        attr="addedToThread"
      />
    </div>
  );
};

MessagesPreferencesLayout.defaultProps = {
  className: '',
};

MessagesPreferencesLayout.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MessagesPreferencesLayout);
